import React, { FunctionComponent } from 'react';
import { Checkbox, CheckboxProps } from 'reakit/Checkbox';

export interface CKSwitchProps extends CheckboxProps {
  id: string;
  srOnly?: boolean;
}

export const CKSwitch: FunctionComponent<CKSwitchProps> = ({
  id,
  srOnly,
  children,
  ...rest
}) => {
  /* NOTE: davidlumley found an odd issue with flexbox and sr-only that created
  // unnecessary padding. See: https://github.com/clearbit/clearkit-one/pull/84
  */
  srOnly = srOnly === undefined ? true : srOnly;
  const className = srOnly ? 'ck-switch-input' : 'ck-switch-input-hidden';

  return (
    <div className="ck-switch">
      <Checkbox id={id} className={className} {...rest} />
      <label htmlFor={id} className="ck-switch-label">
        <div className="ck-switch-track">
          <div className="ck-switch-knob">
            <div className="ck-switch-knob-inner"></div>
          </div>
        </div>
        {children && <span className="ck-switch-text">{children}</span>}
      </label>
    </div>
  );
};
